<template>
  <div class="help">
    <NuxtLink
      to="https://discord.gg/RjHBcZ9mEH"
      target="_blank"
      class="help-button discord"
    >
      <div class="icon" v-html="DiscordSvg"></div>
      <div class="btn-title" v-html="texts[0].title"></div>
      <p class="btn-text" v-html="texts[0].text"></p>
    </NuxtLink>
    <NuxtLink to="" target="_blank" class="help-button telegram disabled">
      <div class="pro-only">Available on <span class="tag">Pro</span></div>
      <div class="icon" v-html="TelegramSvg"></div>
      <div class="btn-title" v-html="texts[1].title"></div>
      <p class="btn-text" v-html="texts[1].text"></p>
    </NuxtLink>
  </div>
</template>

<script setup>
import DiscordSvg from '~/layers/base/assets/icons/discord.svg?raw'
import TelegramSvg from '~/layers/base/assets/icons/telegram-solid.svg?raw'

const textsStore = useTextsStore()
const texts = computed(() => textsStore.account.support.box_help.options)

//TODO: add telegram link/enable button
</script>

<style lang="scss" scoped>
.help {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 20px;

  @media (max-width: 1024px) {
    flex-wrap: wrap;
  }
}

.help-button {
  border-radius: 10px;
  border: 1px solid var(--field-stroke, rgba(0, 0, 0, 0.2));
  padding: 40px;
  text-align: center;
  position: relative;

  .pro-only {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 1.3rem;
    font-weight: 500;

    .tag {
      border-radius: 5px;
      background: #e1dcff;
      color: #654cff;
      padding: 3px 5px;
    }
  }

  &.disabled {
    pointer-events: none;

    .icon,
    .btn-title,
    .btn-text {
      opacity: 0.5;
    }
  }

  .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    width: 50px;
    height: 50px;
    border-radius: 10px;
  }

  &.discord {
    .icon {
      background: rgba(88, 101, 242, 0.15);
    }
  }
  &.telegram {
    .icon {
      background: #36a6de;
    }
  }

  .btn-title {
    font-size: 2.2rem;
    opacity: 0.7;
    font-weight: 500;
    letter-spacing: 0.22px;
  }

  .btn-text {
    font-size: 1.3rem;
    letter-spacing: 0.13px;
  }
}
</style>
